import "firebase/auth";

import * as firebase from "firebase/app";
import Vue from "vue";
import VueGtag from "vue-gtag";
import { validationMixin } from "vuelidate";
import Vuelidate from "vuelidate";

import initI18n from "@/plugins/i18n.ts";
import vuetify from "@/plugins/vuetify.ts";
import { scrollTo, scrollToBottom } from "@/utils/scrollToBottom";

import App from "./App.vue";
import router from "./router";
import store from "./store";
Vue.config.productionTip = false;

let app: Vue | null = null;
const firebaseProjectId = process.env.VUE_APP_FIREBASE_PROJECT_ID;
const firebaseAuthTenantId = process.env.VUE_APP_AUTH_TENANT_ID;

const firebaseConfig = {
  apiKey: process.env.VUE_APP_FIREBASE_API_KEY,
  authDomain: `${firebaseProjectId}.firebaseapp.com`,
  databaseURL: `https://${firebaseProjectId}.firebaseio.com`,
  projectId: firebaseProjectId,
  storageBucket: `${firebaseProjectId}.appspot.com`,
  messagingSenderId: process.env.VUE_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.VUE_APP_FIREBASE_APP_ID,
  measurementId: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID,
};

firebase.initializeApp(firebaseConfig);
if (firebaseAuthTenantId) {
  firebase.auth().tenantId = firebaseAuthTenantId;
}
Vue.use(VueGtag, {
  config: { id: process.env.VUE_APP_FIREBASE_MEASUREMENT_ID },
});
Vue.use(Vuelidate);
Vue.directive("chat", {
  bind: (el, binding) => {
    let scrolled = false;

    el.addEventListener("scroll", (e) => {
      if (el.scrollTop === 0) {
        scrollTo(el, 10, false);
      }
      scrolled = el.scrollTop + el.clientHeight + 1 < el.scrollHeight;
      if (scrolled && el.scrollTop < el.scrollHeight / 5) {
        el.dispatchEvent(new Event("chatTopReached"));
      }
    });

    new MutationObserver((e) => {
      const config = binding.value || {};
      if (config.enabled === false) return;
      const pause = config.always === false && scrolled;
      const addedNodes = e[e.length - 1].addedNodes.length;
      const removedNodes = e[e.length - 1].removedNodes.length;

      if (config.scrollonremoved) {
        if (pause || (addedNodes != 1 && removedNodes != 1)) return;
      } else {
        if (pause || addedNodes != 1) return;
      }

      let smooth = config.smooth;
      const loadingRemoved = !addedNodes && removedNodes === 1;
      if (loadingRemoved && config.scrollonremoved && "smoothonremoved" in config) {
        smooth = config.smoothonremoved;
      }
      scrollToBottom(el, smooth);
    }).observe(el, { childList: true, subtree: true });
  },
  inserted: (el, binding) => {
    const config = binding.value || {};
    scrollToBottom(el, config.notSmoothOnInit ? false : config.smooth);
  },
});

Vue.directive("blur", {
  inserted: function (el) {
    el.onfocus = (ev) => ev && ev.target && el.blur();
  },
});

firebase.auth().onAuthStateChanged(async (user) => {
  if (!app) {
    app = new Vue({
      router,
      store,
      vuetify,
      i18n: await initI18n(),
      mixins: [validationMixin],
      render: (h) => h(App),
    }).$mount("#app");
  }
});
